<template>
  <div :class="(is_show ? 'blueBorder' : '') + ' segment'" ref="option">
    <a class="defaultText" href="javascript:;" @click="toggle">{{
      selected_text
    }}</a>
    <transition name="gas-select">
      <div class="downlayer segmentLayer cartypeLayer" v-show="is_show">
        <div class="downlayerTitle"><p><a href="javascript:;" @click="save" :class="selected_class">确认</a><a href="javascript:;" @click="cancel">取消</a></p><span><a href="#">全部</a></span></div>
        <div class="downlayerBox ">
        <dl v-for="(category, index) in categories" :key="index">
         <dt>{{ Object.values(category)[1] }}</dt>
         <dd>
             <ul>
                 <li :class="value.find(bodysize => bodysize.body_type === category.bodyTypeId) && value.find(bodysize => bodysize.body_type === category.bodyTypeId).global_size.length === 0 ? 'checked' : ''"><a href="javascript:;" @click="checkAll(category)" >全部</a>
                 </li>
         <li v-for="(option, index) in category.globalSizes" 
         :class="value.find(bodysize => bodysize.body_type === category.bodyTypeId) && (value.find(bodysize => bodysize.body_type === category.bodyTypeId).global_size.indexOf(option.globalSizeId) >= 0 || value.find(bodysize => bodysize.body_type === category.bodyTypeId).global_size.length === 0)? 'checked' : ''"
         :key="index" @click="choice(category,option)"><a href="javascript:;">{{ Object.values(option)[1] }}</a></li>
         </ul></dd>
        </dl>
      </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "select-categories",
  props: {
    value: Array,
    text: String,
    width: Number,
    categories: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      selected_text: this.text,
      selected_class: "comitbut",
      options: [],
      current_category: {},
      current_option: {},
      is_show: false,
    };
  },
  watch: {
    value(new_val){
      if(new_val.length === 0)
      {
        this.selected_class = "comitbut";
      }else
      {
        this.selected_class = "blueCommit";
      }
          
    }
  },
  mounted() {
    document.addEventListener("click", (e) => {
      if (this.$refs.option) {
        if (!this.$refs.option.contains(e.target)) {
          this.hide();
        }
      }
    });
  },
  methods: {
    toggle() {
      this.is_show = !this.is_show;
    },
    switch_option(category) {
      this.current_category = category;
      this.options = Object.values(category)[2];
    },
    choice(category,option) {
        let body_sizes = this.value.find(bodysize => bodysize.body_type === category.bodyTypeId);
        if(typeof(body_sizes) == 'undefined'){
            this.value.push({ body_type: category.bodyTypeId, global_size:[option.globalSizeId]})
        }else{
            if(body_sizes.global_size.indexOf(option.globalSizeId) >= 0){
                body_sizes.global_size.length === 1 ? this.value.splice(this.value.indexOf(body_sizes.body_type),1) :
                body_sizes.global_size.splice(body_sizes.global_size.indexOf(option.globalSizeId),1)
            }else{
                body_sizes.global_size.push(option.globalSizeId)
            }
        }
    },
    checkAll(category){
        const body_sizes = this.value.find(bodysize => bodysize.body_type === category.bodyTypeId);
        if(typeof(body_sizes) == 'undefined'){
            
            this.value.push({ body_type: category.bodyTypeId, global_size: []})
        }else{
            if(body_sizes.global_size.length === 0){
                this.value.splice(this.value.indexOf(body_sizes),1)
            }else
            {
                body_sizes.global_size = [];
            }
        }
    },
    save(){
      // this.selected_text = this.selected_text_list.length === 0 ? this.text : this.selected_text_list.join(',');
    //   console.log(this.value)
      // this.selected_class = this.value === [] ? '' : 'blueBorder';  //选项置灰
      this.$emit("input", this.value);
      this.$emit("reset");
      this.hide();
    },
    cancel(){
      // this.value = [];
      // this.selected_text_list = [];
      // this.selected_text = this.text;
      // this.selected_class = '';
      this.$emit("input", []);
      this.$emit("reset");
      this.hide();
    },
    hide() {
      this.is_show = false;
    },
  },
};
</script>
